import { Input } from '@fluentui/react-components';
import { Search20Regular } from '@fluentui/react-icons';
import { useCallback } from 'react';

import type { DatasetSearchProps } from './DatasetSearch.interface.js';
import { useStyles } from './DatasetSearch.style.js';

export function DatasetSearch({
  value,
  onChange,
  placeholder = 'Search datasets...',
  label = 'Search datasets',
}: DatasetSearchProps) {
  const styles = useStyles();

  const handleChange = useCallback(
    (_e: React.ChangeEvent<HTMLInputElement>, data: { value: string }) => {
      onChange(data.value);
    },
    [onChange],
  );

  return (
    <Input
      className={styles.input}
      contentBefore={<Search20Regular />}
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      aria-label={label}
      type="search"
    />
  );
}
